import dataPackageJSON from '../../package.json';

export const version = () => 'v' + dataPackageJSON.version;
